import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { getSeoForRoute } from "./getSeoForRoute";
import { applySeoToDocument } from "./dom";

export function useSeoRoute(entityData = {}, overrides = {}) {
  const location = useLocation();

  const seoResult = useMemo(
    () =>
      getSeoForRoute(location.pathname, entityData, {
        ...overrides,
      }),
    [entityData, location.pathname, overrides]
  );

  useEffect(() => {
    applySeoToDocument(seoResult);
  }, [seoResult]);

  return seoResult;
}

export default useSeoRoute;

